import useAppContext from '~/shared/context/AppContext/useAppContext';
import replaceVariables from './i18n/replaceVariables';
import useToastContext from '@/client/components/Toast/Context/useToastContext';

const useToast = () => {
  const { translations } = useAppContext();
  const { showToast: showToastFn } = useToastContext();

  const showToast = (props: Parameters<typeof showToastFn>[0]) => {
    const translation = translations[props.message] ?? props.message;
    const translateValues = props.translateValues ?? {};
    const message = replaceVariables(translation, translateValues);
    showToastFn({ ...props, message });
  };

  return { showToast };
};

export default useToast;
